"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$requestPostFile = exports.$requestGetFilePostUrl = exports.$putFeedItem = exports.$postFeedItem = exports.$patchFeedItem = exports.$getPreviousFeedItems = exports.$getNextFeedItems = exports.$getLastFilesFeedItems = exports.$getDeltaFeedItems = exports.$deleteFeedItem = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var _constants = require("./constants");
var _qs = _interopRequireDefault(require("qs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var base = '/feed';
var $deleteFeedItem = (_feed, _feedItem) => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_feed, "/feedItems/").concat(_feedItem)
});
exports.$deleteFeedItem = $deleteFeedItem;
var $getDeltaFeedItems = (_feed, lastUpdatedAt) => {
  var options = {};
  if (lastUpdatedAt) options.lastUpdatedAt = lastUpdatedAt;
  var url = "/v5/feeds/".concat(_feed, "/delta?").concat(_qs.default.stringify(options));
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url
  });
};
exports.$getDeltaFeedItems = $getDeltaFeedItems;
var $getLastFilesFeedItems = (_feed, limit) => {
  var pathname = _feed ? "".concat(base, "/").concat(_feed, "/feedItems") : "".concat(base, "/feedItems");
  var url = "".concat(pathname, "?").concat(_qs.default.stringify({
    limit,
    filterType: 'file',
    orderBy: {
      key: 'createdAt',
      order: 'desc'
    }
  }));
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url
  });
};
exports.$getLastFilesFeedItems = $getLastFilesFeedItems;
var $getPreviousFeedItems = exports.$getPreviousFeedItems = function $getPreviousFeedItems(_feed, _lastFeedItem, lastCreatedAt) {
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.LAZYLOAD_LIMIT;
  var options = {
    limit
  };
  if (_lastFeedItem) options._lastFeedItem = _lastFeedItem;
  if (lastCreatedAt) options.lastCreatedAt = lastCreatedAt;
  var url = "/v5/feeds/".concat(_feed, "/previousFeedItems?").concat(_qs.default.stringify(options));
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url
  });
};
var $getNextFeedItems = exports.$getNextFeedItems = function $getNextFeedItems(_feed, _feedItem, feedItemCreationDate) {
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.LAZYLOAD_LIMIT;
  var options = {
    limit
  };
  if (_feedItem) options._feedItem = _feedItem;
  if (feedItemCreationDate) options.feedItemCreationDate = feedItemCreationDate;
  var url = "/v5/feeds/".concat(_feed, "/nextFeedItems?").concat(_qs.default.stringify(options));
  return (0, _oldHttpClient.apiClient)({
    method: 'get',
    url
  });
};
var $patchFeedItem = (_feed, _feedItem, body) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_feed, "/feedItems/").concat(_feedItem),
  body
});
exports.$patchFeedItem = $patchFeedItem;
var $postFeedItem = (_feed, body) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_feed, "/feedItems"),
  body
});
exports.$postFeedItem = $postFeedItem;
var $putFeedItem = feedItem => (0, _oldHttpClient.apiClient)({
  method: 'put',
  url: "".concat(base, "/").concat(feedItem._feed, "/feedItems/").concat(feedItem.id),
  body: feedItem
});
exports.$putFeedItem = $putFeedItem;
var $requestGetFilePostUrl = _feed => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_feed, "/postUrl")
});
exports.$requestGetFilePostUrl = $requestGetFilePostUrl;
var $requestPostFile = (formdata, url, onUploadProgress) => {
  var _window, _window2;
  // eslint-disable-next-line no-undef
  var data = new FormData();

  // for web only
  if (typeof window === 'object' && ((_window = window) !== null && _window !== void 0 && _window.File && formdata instanceof window.File || (_window2 = window) !== null && _window2 !== void 0 && _window2.Blob && formdata instanceof window.Blob)) {
    data.append('file', formdata);
  } else {
    data.append('file', {
      uri: formdata.file,
      type: formdata.type || 'image/jpeg',
      name: formdata.filename
    });
  }
  return (0, _oldHttpClient.getAxiosProvider)()({
    method: 'post',
    data,
    url,
    timeout: 0,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  });
};
exports.$requestPostFile = $requestPostFile;